"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// The Wasm Terminal
// @ts-ignore
var xterm_1 = __importDefault(require("xterm"));
var xtermDefault = __importStar(require("xterm"));
var Terminal = xtermDefault.Terminal || xterm_1.default.Terminal;
var xterm_addon_fit_1 = require("xterm-addon-fit");
var xterm_addon_web_links_1 = require("xterm-addon-web-links");
var wasm_terminal_config_1 = __importDefault(require("./wasm-terminal-config"));
var wasm_tty_1 = __importDefault(require("./wasm-tty/wasm-tty"));
var wasm_shell_1 = __importDefault(require("./wasm-shell/wasm-shell"));
var MOBILE_KEYBOARD_EVENTS = ["click", "tap"];
var WasmTerminal = /** @class */ (function () {
    function WasmTerminal(config) {
        var _this = this;
        /**
         * Handle terminal resize
         *
         * This function clears the prompt using the previous configuration,
         * updates the cached terminal size information and then re-renders the
         * input. This leads (most of the times) into a better formatted input.
         */
        this.handleTermResize = function (data) {
            var rows = data.rows, cols = data.cols;
            _this.wasmTty.clearInput();
            _this.wasmTty.setTermSize(cols, rows);
            _this.wasmTty.setInput(_this.wasmTty.getInput(), true);
        };
        this.wasmTerminalConfig = new wasm_terminal_config_1.default(config);
        // Create our xterm element
        this.xterm = new Terminal({ scrollback: 10000, fontSize: 14, theme: { background: '#1a1c1f' }, cols: 100 });
        // tslint:disable-next-line
        // this.pasteEvent = this.xterm.on("paste", this.onPaste);
        // tslint:disable-next-line
        this.resizeEvent = this.xterm.onResize(this.handleTermResize);
        this.xterm.onKey(function (keyEvent) {
            // Fix for iOS Keyboard Jumping on space
            if (keyEvent.key === " ") {
                keyEvent.domEvent.preventDefault();
            }
        });
        // Set up our container
        this.container = undefined;
        // Load our addons
        this.webLinksAddon = new xterm_addon_web_links_1.WebLinksAddon();
        this.fitAddon = new xterm_addon_fit_1.FitAddon();
        this.xterm.loadAddon(this.fitAddon);
        this.xterm.loadAddon(this.webLinksAddon);
        this.wasmTerminalConfig = new wasm_terminal_config_1.default(config);
        // Create our Shell and tty
        this.wasmTty = new wasm_tty_1.default(this.xterm);
        this.wasmShell = new wasm_shell_1.default(this.wasmTerminalConfig, this.wasmTty, {
            disablePrompt: false,
        });
        // tslint:disable-next-line
        this.dataEvent = this.xterm.onData(this.wasmShell.handleTermData);
        this.isOpen = false;
        this.pendingPrintOnOpen = "";
    }
    WasmTerminal.prototype.open = function (container) {
        var _this = this;
        // Remove any current event listeners
        var focusHandler = this.focus.bind(this);
        if (this.container !== undefined) {
            MOBILE_KEYBOARD_EVENTS.forEach(function (eventName) {
                _this.container.removeEventListener(eventName, focusHandler);
            });
        }
        this.container = container;
        this.xterm.open(container);
        this.isOpen = true;
        setTimeout(function () {
            // Fix for Mobile Browsers and their virtual keyboards
            if (_this.container !== undefined) {
                MOBILE_KEYBOARD_EVENTS.forEach(function (eventName) {
                    _this.container.addEventListener(eventName, focusHandler);
                });
            }
            if (_this.pendingPrintOnOpen) {
                _this.wasmTty.print(_this.pendingPrintOnOpen + "\n");
                _this.pendingPrintOnOpen = "";
            }
        });
    };
    WasmTerminal.prototype.fit = function () {
        this.fitAddon.fit();
    };
    WasmTerminal.prototype.clear = function () {
        this.xterm.clear();
    };
    WasmTerminal.prototype.focus = function () {
        this.xterm.focus();
    };
    WasmTerminal.prototype.print = function (message, sync) {
        var _this = this;
        // For some reason, double new lines are not respected. Thus, fixing that here
        message = message.replace(/\n\n/g, "\n \n");
        if (!this.isOpen) {
            if (this.pendingPrintOnOpen) {
                this.pendingPrintOnOpen += message;
            }
            else {
                this.pendingPrintOnOpen = message;
            }
            return;
        }
        if (this.wasmShell.isPrompting()) {
            // Cancel the current prompt and restart
            this.wasmShell.printAndRestartPrompt(function () {
                _this.wasmTty.print(message + "\n", sync);
                return undefined;
            });
            return;
        }
        this.wasmTty.print(message, sync);
    };
    WasmTerminal.prototype.kill = function () {
        // return this.wasmShell.commandRunner?.kill();
    };
    WasmTerminal.prototype.destroy = function () {
        this.xterm.dispose();
        delete this.xterm;
    };
    WasmTerminal.prototype.onPaste = function (data) {
        this.wasmTty.print(data);
    };
    return WasmTerminal;
}());
exports.default = WasmTerminal;
